// automatically generated by the FlatBuffers compiler, do not modify

import * as NS115100186165309685 from "./Types";
/**
 * @enum {number}
 */
export namespace com.tableausoftware.endeavour.protocol.v1.trace{
export enum StatusCode{
  STATUS_CODE_OK= 0,
  STATUS_CODE_CANCELLED= 1,
  STATUS_CODE_UNKNOWN_ERROR= 2,
  STATUS_CODE_INVALID_ARGUMENT= 3,
  STATUS_CODE_DEADLINE_EXCEEDED= 4,
  STATUS_CODE_NOT_FOUND= 5,
  STATUS_CODE_ALREADY_EXISTS= 6,
  STATUS_CODE_PERMISSION_DENIED= 7,
  STATUS_CODE_RESOURCE_EXHAUSTED= 8,
  STATUS_CODE_FAILED_PRECONDITION= 9,
  STATUS_CODE_ABORTED= 10,
  STATUS_CODE_OUT_OF_RANGE= 11,
  STATUS_CODE_UNIMPLEMENTED= 12,
  STATUS_CODE_INTERNAL_ERROR= 13,
  STATUS_CODE_UNAVAILABLE= 14,
  STATUS_CODE_DATA_LOSS= 15,
  STATUS_CODE_UNAUTHENTICATED= 16
}};

/**
 * @enum {number}
 */
export namespace com.tableausoftware.endeavour.protocol.v1.trace{
export enum SpanKind{
  SPAN_KIND_UNSPECIFIED= 0,
  SPAN_KIND_INTERNAL= 1,
  SPAN_KIND_SERVER= 2,
  SPAN_KIND_CLIENT= 3,
  SPAN_KIND_PRODUCER= 4,
  SPAN_KIND_CONSUMER= 5
}};

/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.trace{
export class Status {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns Status
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Status {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Status= obj
 * @returns Status
 */
static getRootAsStatus(bb:flatbuffers.ByteBuffer, obj?:Status):Status {
  return (obj || new Status()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Status= obj
 * @returns Status
 */
static getSizePrefixedRootAsStatus(bb:flatbuffers.ByteBuffer, obj?:Status):Status {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Status()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.trace.StatusCode
 */
code():com.tableausoftware.endeavour.protocol.v1.trace.StatusCode {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.trace.StatusCode.STATUS_CODE_OK;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
message():string|null
message(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
message(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startStatus(builder:flatbuffers.Builder) {
  builder.startObject(2);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.trace.StatusCode code
 */
static addCode(builder:flatbuffers.Builder, code:com.tableausoftware.endeavour.protocol.v1.trace.StatusCode) {
  builder.addFieldInt8(0, code, com.tableausoftware.endeavour.protocol.v1.trace.StatusCode.STATUS_CODE_OK);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset messageOffset
 */
static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endStatus(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createStatus(builder:flatbuffers.Builder, code:com.tableausoftware.endeavour.protocol.v1.trace.StatusCode, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  Status.startStatus(builder);
  Status.addCode(builder, code);
  Status.addMessage(builder, messageOffset);
  return Status.endStatus(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.trace{
export class Event {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns Event
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Event {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Event= obj
 * @returns Event
 */
static getRootAsEvent(bb:flatbuffers.ByteBuffer, obj?:Event):Event {
  return (obj || new Event()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Event= obj
 * @returns Event
 */
static getSizePrefixedRootAsEvent(bb:flatbuffers.ByteBuffer, obj?:Event):Event {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Event()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns flatbuffers.Long
 */
timeUnixNano():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
name():string|null
name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
name(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue
 */
customAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
customAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue
 */
standardAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
standardAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns number
 */
droppedAttributesCount():number {
  var offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startEvent(builder:flatbuffers.Builder) {
  builder.startObject(5);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long timeUnixNano
 */
static addTimeUnixNano(builder:flatbuffers.Builder, timeUnixNano:flatbuffers.Long) {
  builder.addFieldInt64(0, timeUnixNano, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset nameOffset
 */
static addName(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, nameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset customAttributesOffset
 */
static addCustomAttributes(builder:flatbuffers.Builder, customAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, customAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createCustomAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startCustomAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset standardAttributesOffset
 */
static addStandardAttributes(builder:flatbuffers.Builder, standardAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, standardAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createStandardAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startStandardAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param number droppedAttributesCount
 */
static addDroppedAttributesCount(builder:flatbuffers.Builder, droppedAttributesCount:number) {
  builder.addFieldInt32(4, droppedAttributesCount, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endEvent(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createEvent(builder:flatbuffers.Builder, timeUnixNano:flatbuffers.Long, nameOffset:flatbuffers.Offset, customAttributesOffset:flatbuffers.Offset, standardAttributesOffset:flatbuffers.Offset, droppedAttributesCount:number):flatbuffers.Offset {
  Event.startEvent(builder);
  Event.addTimeUnixNano(builder, timeUnixNano);
  Event.addName(builder, nameOffset);
  Event.addCustomAttributes(builder, customAttributesOffset);
  Event.addStandardAttributes(builder, standardAttributesOffset);
  Event.addDroppedAttributesCount(builder, droppedAttributesCount);
  return Event.endEvent(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.trace{
export class Span {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns Span
 */
__init(i:number, bb:flatbuffers.ByteBuffer):Span {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Span= obj
 * @returns Span
 */
static getRootAsSpan(bb:flatbuffers.ByteBuffer, obj?:Span):Span {
  return (obj || new Span()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param Span= obj
 * @returns Span
 */
static getSizePrefixedRootAsSpan(bb:flatbuffers.ByteBuffer, obj?:Span):Span {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Span()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @returns number
 */
traceId(index: number):number|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
};

/**
 * @returns number
 */
traceIdLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns Uint8Array
 */
traceIdArray():Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? new Uint8Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param number index
 * @returns number
 */
spanId(index: number):number|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
};

/**
 * @returns number
 */
spanIdLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns Uint8Array
 */
spanIdArray():Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? new Uint8Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
traceState():string|null
traceState(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
traceState(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param number index
 * @returns number
 */
parentSpanId(index: number):number|null {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
};

/**
 * @returns number
 */
parentSpanIdLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns Uint8Array
 */
parentSpanIdArray():Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? new Uint8Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
name():string|null
name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
name(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.trace.SpanKind
 */
kind():com.tableausoftware.endeavour.protocol.v1.trace.SpanKind {
  var offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.trace.SpanKind.SPAN_KIND_UNSPECIFIED;
};

/**
 * @returns flatbuffers.Long
 */
startTimeUnixNano():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @returns flatbuffers.Long
 */
endTimeUnixNano():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue
 */
customAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
customAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue
 */
standardAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
standardAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns number
 */
droppedAttributesCount():number {
  var offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.trace.Event= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.trace.Event
 */
events(index: number, obj?:com.tableausoftware.endeavour.protocol.v1.trace.Event):com.tableausoftware.endeavour.protocol.v1.trace.Event|null {
  var offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? (obj || new com.tableausoftware.endeavour.protocol.v1.trace.Event()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
eventsLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns number
 */
droppedEventsCount():number {
  var offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
};

/**
 * @param com.tableausoftware.endeavour.protocol.v1.trace.Status= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.trace.Status|null
 */
status(obj?:com.tableausoftware.endeavour.protocol.v1.trace.Status):com.tableausoftware.endeavour.protocol.v1.trace.Status|null {
  var offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? (obj || new com.tableausoftware.endeavour.protocol.v1.trace.Status()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startSpan(builder:flatbuffers.Builder) {
  builder.startObject(14);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset traceIdOffset
 */
static addTraceId(builder:flatbuffers.Builder, traceIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, traceIdOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<number> data
 * @returns flatbuffers.Offset
 */
static createTraceIdVector(builder:flatbuffers.Builder, data:number[] | Uint8Array):flatbuffers.Offset {
  builder.startVector(1, data.length, 1);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addInt8(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startTraceIdVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(1, numElems, 1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset spanIdOffset
 */
static addSpanId(builder:flatbuffers.Builder, spanIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, spanIdOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<number> data
 * @returns flatbuffers.Offset
 */
static createSpanIdVector(builder:flatbuffers.Builder, data:number[] | Uint8Array):flatbuffers.Offset {
  builder.startVector(1, data.length, 1);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addInt8(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startSpanIdVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(1, numElems, 1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset traceStateOffset
 */
static addTraceState(builder:flatbuffers.Builder, traceStateOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, traceStateOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset parentSpanIdOffset
 */
static addParentSpanId(builder:flatbuffers.Builder, parentSpanIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, parentSpanIdOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<number> data
 * @returns flatbuffers.Offset
 */
static createParentSpanIdVector(builder:flatbuffers.Builder, data:number[] | Uint8Array):flatbuffers.Offset {
  builder.startVector(1, data.length, 1);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addInt8(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startParentSpanIdVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(1, numElems, 1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset nameOffset
 */
static addName(builder:flatbuffers.Builder, nameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, nameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.trace.SpanKind kind
 */
static addKind(builder:flatbuffers.Builder, kind:com.tableausoftware.endeavour.protocol.v1.trace.SpanKind) {
  builder.addFieldInt8(5, kind, com.tableausoftware.endeavour.protocol.v1.trace.SpanKind.SPAN_KIND_UNSPECIFIED);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long startTimeUnixNano
 */
static addStartTimeUnixNano(builder:flatbuffers.Builder, startTimeUnixNano:flatbuffers.Long) {
  builder.addFieldInt64(6, startTimeUnixNano, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long endTimeUnixNano
 */
static addEndTimeUnixNano(builder:flatbuffers.Builder, endTimeUnixNano:flatbuffers.Long) {
  builder.addFieldInt64(7, endTimeUnixNano, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset customAttributesOffset
 */
static addCustomAttributes(builder:flatbuffers.Builder, customAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, customAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createCustomAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startCustomAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset standardAttributesOffset
 */
static addStandardAttributes(builder:flatbuffers.Builder, standardAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, standardAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createStandardAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startStandardAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param number droppedAttributesCount
 */
static addDroppedAttributesCount(builder:flatbuffers.Builder, droppedAttributesCount:number) {
  builder.addFieldInt32(10, droppedAttributesCount, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset eventsOffset
 */
static addEvents(builder:flatbuffers.Builder, eventsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(11, eventsOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createEventsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startEventsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param number droppedEventsCount
 */
static addDroppedEventsCount(builder:flatbuffers.Builder, droppedEventsCount:number) {
  builder.addFieldInt32(12, droppedEventsCount, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset statusOffset
 */
static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(13, statusOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endSpan(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createSpan(builder:flatbuffers.Builder, traceIdOffset:flatbuffers.Offset, spanIdOffset:flatbuffers.Offset, traceStateOffset:flatbuffers.Offset, parentSpanIdOffset:flatbuffers.Offset, nameOffset:flatbuffers.Offset, kind:com.tableausoftware.endeavour.protocol.v1.trace.SpanKind, startTimeUnixNano:flatbuffers.Long, endTimeUnixNano:flatbuffers.Long, customAttributesOffset:flatbuffers.Offset, standardAttributesOffset:flatbuffers.Offset, droppedAttributesCount:number, eventsOffset:flatbuffers.Offset, droppedEventsCount:number, statusOffset:flatbuffers.Offset):flatbuffers.Offset {
  Span.startSpan(builder);
  Span.addTraceId(builder, traceIdOffset);
  Span.addSpanId(builder, spanIdOffset);
  Span.addTraceState(builder, traceStateOffset);
  Span.addParentSpanId(builder, parentSpanIdOffset);
  Span.addName(builder, nameOffset);
  Span.addKind(builder, kind);
  Span.addStartTimeUnixNano(builder, startTimeUnixNano);
  Span.addEndTimeUnixNano(builder, endTimeUnixNano);
  Span.addCustomAttributes(builder, customAttributesOffset);
  Span.addStandardAttributes(builder, standardAttributesOffset);
  Span.addDroppedAttributesCount(builder, droppedAttributesCount);
  Span.addEvents(builder, eventsOffset);
  Span.addDroppedEventsCount(builder, droppedEventsCount);
  Span.addStatus(builder, statusOffset);
  return Span.endSpan(builder);
}
}
}
